// Global vars
import { mediaQuery, templateDir } from './global.var';

// Get Lottie element
const lottieElement = document.getElementById('homeLottie');

function fillSvg() {
  // Define filler svg location
  const svgLocation = `${templateDir}/assets/img/graphic/style-ele-shadow-noFish.svg`;

  // Create dom object
  const styleSVG = document.createElement('img');
  styleSVG.src = svgLocation;
  styleSVG.alt = 'style element';

  // Remove content from dom element, and add the image
  lottieElement.innerHTML = '';
  lottieElement.prepend(styleSVG);
}

function checkForLottie() {
  if (mediaQuery.mobileLarge.matches) {
    fillSvg();
  } else {
    import(
      /* webpackChunkName: 'lottieInitializer' */ './components/animation/lottie-paralax'
    ).then((module) => {
      const exportedInit = module.default;

      // Remove content from dom element, and add animation
      lottieElement.innerHTML = '';
      exportedInit();
    });
  }
}

if (lottieElement) {
  mediaQuery.mobileLarge.addEventListener('change', checkForLottie);

  document.addEventListener('DOMContentLoaded', () => {
    checkForLottie();
  });
}
